import React from 'react';

interface DynamicFooterProps {
  currentPath: string;
}

export const DynamicFooter: React.FC<DynamicFooterProps> = ({ currentPath }) => {
  const getFooterContent = () => {
    switch (currentPath) {
      case '#dashboard':
        return {
          left: 'Dashboard Overview',
          center: 'Summary of your financial health and recent activities.',
          links: ['Generate Report', 'View Analytics']
        };
      case '#customer-mgmt':
        return {
          left: 'Customer Management',
          center: 'Manage your client relationships, credit limits, and balances.',
          links: ['Import Customers', 'Export List']
        };
      case '#invoicing':
        return {
          left: 'Invoicing & Billing',
          center: 'Create, send, and track invoices and payments.',
          links: ['Invoice Templates', 'Tax Configuration']
        };
      case '#credit-mgmt':
        return {
          left: 'Credit Management',
          center: 'Review credit requests and adjust customer credit limits.',
          links: ['Credit Policy', 'Risk Assessment']
        };
      case '#aging-reports':
        return {
          left: 'Aging Reports',
          center: 'Analyze outstanding balances and overdue accounts.',
          links: ['Schedule Reports', 'Collection Strategy']
        };
      case '#vendor-mgmt':
        return {
          left: 'Vendor Management',
          center: 'Manage suppliers, purchase orders, and outgoing payments.',
          links: ['Add Vendor', 'Expense Categories']
        };
      default:
        return {
          left: 'Majelani Accounting',
          center: 'Next-generation accounting platform powered by artificial intelligence.',
          links: ['Help Center', 'Support']
        };
    }
  };

  const content = getFooterContent();

  return (
    <footer className="hidden sm:flex bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800/60 py-2 sm:py-3 px-3 sm:px-6 flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-0 text-xs text-slate-500 dark:text-slate-400 z-20 shrink-0">
      <div className="flex items-center gap-2 sm:gap-6 min-w-0">
        <span className="font-bold text-slate-700 dark:text-slate-300 truncate">{content.left}</span>
        <span className="hidden md:inline-block text-slate-400 dark:text-slate-500 truncate">{content.center}</span>
      </div>
      <div className="flex items-center gap-2 sm:gap-4 flex-wrap">
        <div className="flex items-center gap-2 px-2 py-1 bg-emerald-500/10 dark:bg-emerald-500/5 rounded-full border border-emerald-500/20">
          <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(16,185,129,0.5)]" />
          <span className="text-[10px] font-bold text-emerald-600 dark:text-emerald-400 uppercase tracking-wider">Online</span>
        </div>
        <span className="hidden sm:inline text-slate-300 dark:text-slate-700">|</span>
        <span className="hidden sm:inline">© 2024 Majelani</span>
      </div>
    </footer>
  );
};
